export enum ApiEventMessage {
  Changed = 'changed',
  Added = 'added',
  Removed = 'removed',
  Result = 'result',
  Connected = 'connected',
  Connect = 'connect',
  NoSub = 'nosub',
  UnSub = 'unsub',
  Pong = 'pong',
  Sub = 'sub',
  Ping = 'ping',
  Method = 'method',
}
